/**
 * edg-brinde-shaker.js — Empório da Garrafa
 * "Comprou Shaker, ganhou o Pote": põe 1 pote hermético no carrinho para cada Activate Shaker Stanley.
 * O preço zero vem do desconto automático BXGY "Comprou Shaker, ganhou o Pote" (Shopify); este script só põe e tira o item.
 *  - o pote do brinde leva a propriedade oculta _brinde=pote-shaker (o tema não mostra propriedades com "_")
 *  - a cor do pote acompanha a do shaker; cor esgotada → primeira disponível
 *  - pote que o próprio cliente pôs conta como brinde (o desconto cobre qualquer pote)
 *  - quem tira o pote não o recebe de volta enquanto a quantidade de shakers não mudar
 *  - se o desconto não cobrir o pote (outro desconto que não acumula venceu), o pote do brinde sai:
 *    nunca cobra por um item que o cliente não escolheu
 */
(function () {
  'use strict';

  var TAG = 'pote-shaker';
  var SHAKER = 8248055627962;
  var POTE_PRODUTO = 8285610639546;
  var POTE_URL = 'products/pote-hermetico-para-activate-shaker.js';
  var POTE = { grey: 45427891765434, twilight: 45427891798202, black: 45427891830970, white: 45427891863738 };
  var COR = {
    'black': 'black', 'sage grey': 'grey', 'twilight': 'twilight', 'chalk': 'white',
    'rose quartz': 'white', 'dark blossom': 'black', 'cobalt chartreuse': 'twilight'
  };
  var K_QTD = 'edg_brinde_shaker_qtd';
  var K_NEGADO = 'edg_brinde_shaker_negado';
  var FONTE = 'edg-brinde';

  var nativeFetch = window.fetch.bind(window);
  var timer = null, rodando = false, deNovo = false, disp = null;

  function sessao(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { /* aba anônima sem storage: segue sem memória */ }
    return null;
  }

  function raiz() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function pedir(caminho, corpo) {
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (corpo) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(corpo);
    }
    return nativeFetch(raiz() + caminho, opts).then(function (r) { return r.json(); });
  }

  function soma(linhas) {
    return linhas.reduce(function (s, i) { return s + i.quantity; }, 0);
  }

  function ehBrinde(i) {
    return !!(i.properties && i.properties._brinde === TAG);
  }

  function assinatura(cart) {
    return cart.items.filter(function (i) { return !ehBrinde(i); })
      .map(function (i) { return i.variant_id + ':' + i.quantity; }).sort().join(',');
  }

  function disponibilidade() {
    if (disp) return Promise.resolve(disp);
    return pedir(POTE_URL).then(function (p) {
      disp = {};
      (p.variants || []).forEach(function (v) { disp[v.id] = !!v.available; });
      return disp;
    }).catch(function () {
      disp = {};
      Object.keys(POTE).forEach(function (k) { disp[POTE[k]] = true; });
      return disp;
    });
  }

  function poteDaCor(shaker, d) {
    var id = POTE[COR[String(shaker.variant_title || '').toLowerCase()] || 'black'];
    if (d[id] !== false) return id;
    for (var k in POTE) if (d[POTE[k]]) return POTE[k];
    return null;
  }

  function agendar(ms) {
    clearTimeout(timer);
    timer = setTimeout(conferir, ms || 400);
  }

  // Redesenha gaveta, carrinho e contador do tema com o carrinho atualizado
  function avisarTema(cart) {
    var secoes = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: secoes } }));
    var publicar = function (sections) {
      if (sections) cart.sections = sections;
      if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: FONTE, cart: cart });
    };
    if (!secoes.length) return publicar(null);
    return nativeFetch(raiz() + '?sections=' + encodeURIComponent(secoes.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(publicar).catch(function () { publicar(null); });
  }

  function conferir() {
    if (rodando) { deNovo = true; return; }
    rodando = true;
    var mexeu = false;

    pedir('cart.js').then(function (cart) {
      var shakers = cart.items.filter(function (i) { return i.product_id === SHAKER; });
      var brindes = cart.items.filter(ehBrinde);
      var potesProprios = cart.items.filter(function (i) { return i.product_id === POTE_PRODUTO && !ehBrinde(i); });
      var qShaker = soma(shakers);
      var qBrinde = soma(brindes);
      var antes = sessao(K_QTD);
      sessao(K_QTD, String(qShaker));

      var alvo = Math.max(0, qShaker - soma(potesProprios));
      // shakers iguais aos da última conferência: o cliente pode ter tirado o pote, então só diminui
      if (antes !== null && Number(antes) === qShaker) alvo = Math.min(alvo, qBrinde);
      if (sessao(K_NEGADO) === assinatura(cart)) alvo = 0;

      if (alvo < qBrinde) {
        var sobra = qBrinde - alvo, updates = {};
        for (var n = brindes.length - 1; n >= 0 && sobra > 0; n--) {
          var tira = Math.min(sobra, brindes[n].quantity);
          updates[brindes[n].key] = brindes[n].quantity - tira;
          sobra -= tira;
        }
        mexeu = true;
        return pedir('cart/update.js', { updates: updates });
      }
      if (alvo > qBrinde) {
        return disponibilidade().then(function (d) {
          var falta = alvo - qBrinde, desejo = {}, ordem = [];
          shakers.forEach(function (s) {
            var id = poteDaCor(s, d);
            if (!id) return;
            if (!(id in desejo)) { desejo[id] = 0; ordem.push(id); }
            desejo[id] += s.quantity;
          });
          brindes.forEach(function (b) { if (b.variant_id in desejo) desejo[b.variant_id] -= b.quantity; });
          var itens = [];
          ordem.forEach(function (id) {
            var q = Math.min(falta, Math.max(0, desejo[id]));
            if (q > 0) { itens.push({ id: id, quantity: q, properties: { _brinde: TAG } }); falta -= q; }
          });
          if (falta > 0 && ordem.length) {
            var mesmo = itens.filter(function (i) { return i.id === ordem[0]; })[0];
            if (mesmo) mesmo.quantity += falta;
            else itens.push({ id: ordem[0], quantity: falta, properties: { _brinde: TAG } });
          }
          if (!itens.length) return null;
          mexeu = true;
          return pedir('cart/add.js', { items: itens });
        });
      }
      return null;
    }).then(function () {
      if (!mexeu) return null;
      return pedir('cart.js').then(function (cart) {
        // o desconto precisa cobrir o pote do brinde; se não cobriu, o brinde sai
        var cobrados = cart.items.filter(function (i) { return ehBrinde(i) && i.final_line_price > 0; });
        if (!cobrados.length) return cart;
        var updates = {};
        cobrados.forEach(function (i) { updates[i.key] = 0; });
        return pedir('cart/update.js', { updates: updates }).then(function (novo) {
          sessao(K_NEGADO, assinatura(novo));
          return novo;
        });
      }).then(avisarTema);
    }).catch(function (e) {
      if (window.console) console.warn('[edg-brinde]', e);
    }).then(function () {
      rodando = false;
      if (deNovo) { deNovo = false; agendar(); }
    });
  }

  // Qualquer mexida no carrinho feita por outro código (tema, apps, plugin de gravação) dispara a conferência
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { agendar(); }, function () {});
    } catch (e) { /* nada */ }
    return p;
  };

  function iniciar() {
    if (window.theme && theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== FONTE) agendar();
      });
    }
    document.addEventListener('cart:refresh', function () { agendar(); });
    var contador = document.querySelector('cart-count');
    var itens = contador ? parseInt(contador.textContent, 10) : NaN;
    if (!contador || itens > 0) agendar(50);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
